import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardComponent} from './dashboard/dashboard.component';
import {LoginComponent} from './login/login.component';
import {IndustryComponent} from './industry/industry.component';
import {CemsComponent} from './cems/cems.component';
import {ReportComponent} from './report/report.component';
import {ManagementComponent} from './management/management.component';
import {PublicComponent} from './public/public.component';
import {IndustryPublicViewComponent} from './industry-public-view/industry-public-view.component';
import {SlideShowComponent} from './slide-show/slide-show.component';
import {IndustryEditComponent} from './industry-edit/industry-edit.component';
import {AboutUsComponent} from './about-us/about-us.component';
import {PublicSlideShowComponent} from './public-slide-show/public-slide-show.component';
import {CloseReportComponent} from './close-report/close-report.component';
import {CloseReportListComponent} from './close-report-list/close-report-list.component';
import {SmsReportListComponent} from './sms-report-list/sms-report-list.component';
import {ExceedanceReportListComponent} from './exceedance-report-list/exceedance-report-list.component';
import {ArchiveIndustryComponent} from './archive-industry/archive-industry.component';
import {GeneralDailyReportComponent} from './general-daily-report/general-daily-report.component';
import {ExceedanceDailyReportComponent} from './exceedance-daily-report/exceedance-daily-report.component';
import {OfflineDailyReportComponent} from './offline-daily-report/offline-daily-report.component';
import {DelayDailyReportComponent} from './delay-daily-report/delay-daily-report.component';
import {StationParameterReportComponent} from './station-parameter-report/station-parameter-report.component';
import {AddDetailsComponent} from './add-details/add-details.component';
import {DashboardV2Component} from './dashboard-v2/dashboard-v2.component';

const routes: Routes = [

  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  }, {
    path: 'dashboard',
    component: DashboardComponent
  }, {
    path: 'login',
    component: LoginComponent
  }, {
    path: 'industry',
    component: IndustryComponent
  }, {
    path: 'industry-edit',
    component: IndustryEditComponent
  }, {
    path: 'cems',
    component: CemsComponent
  }, {
    path: 'close-report',
    component: CloseReportListComponent
  }, {
    path: 'sms-report',
    component: SmsReportListComponent
  }, {
    path: 'exceedance-report',
    component: ExceedanceReportListComponent
  }, {
    path: 'management',
    component: ManagementComponent
  }, {
    path: 'public',
    component: PublicComponent
  }, {
    path: 'about',
    component: AboutUsComponent
  }, {
    path: 'industry-public-view',
    component: IndustryPublicViewComponent
  }, {
    path: 'slideshow',
    component: SlideShowComponent
  }, {
    path: 'publicSlideshow',
    component: PublicSlideShowComponent
  }, {
    path: 'archive-industry',
    component: ArchiveIndustryComponent
  }, {
    path: 'general-industry-report',
    component: GeneralDailyReportComponent
  }, {
    path: 'exceedance-industry-report',
    component: ExceedanceDailyReportComponent
  }, {
    path: 'offline-industry-report',
    component: OfflineDailyReportComponent
  }, {
    path: 'delay-industry-report',
    component: DelayDailyReportComponent
  }, {
    path: 'station-parameter-report',
    component: StationParameterReportComponent
  }, {
    path: 'add-details',
    component: AddDetailsComponent
  }, {
    path: 'djb-dashboard',
    component: DashboardV2Component
  }, {
    path: '**',
    redirectTo: '404-error'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
